import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const AboutSection = () => {
  const sectionRef = useRef(null);
  const headingRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("active");
          } else {
            if (e.boundingClientRect.top > 0) {
              e.target.classList.remove("active");
            }
          }
        });
      },
      { threshold: 0.15 }
    );

    if (headingRef.current) observer.observe(headingRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="hp-about hp-section" style={{ backgroundImage: "url('/kuku-assets/images/section-bg-pattern.png')" }}>
      <div className="container mx-auto px-4 flex flex-wrap justify-center gap-6 md:gap-10" ref={sectionRef}>
        <div className="text-center w-full">
          <img
            src="/kuku-assets/images/60years.png"
            alt="60 Years of Legacy"
            className="inline-block mb-2 sixty-yr"
          />
          <img
            src="/kuku-assets/images/heart64.png"
            alt="Heart"
            className="inline-block mx-2"
          />
          <h3 className="hp-heading mt-3 mb-4">Serving Taste of Tradition</h3>
          <p className="max-w-[1320px] mx-auto text-base leading-relaxed" style={{ fontSize: "1.2rem" }}>
            Kuku Namkeen, founded in 1965 in Jamnagar, is a name synonymous with authentic taste and
            timeless tradition. Renowned for its iconic Jamnagari kachori and premium namkeen and
            sweets, Kuku Namkeen blends heritage recipes with uncompromising quality. Each product
            reflects decades of passion, trust, and craftsmanship, delighting generations in India
            and across the world with flavors that truly stand the test of time.
          </p>
          <Link to="/about" className="hp-btn-kuku mt-4 px-6 py-2">
            Know us
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
